/**
 * Derivations shared by every surface that renders a workflow summary card
 * (the workflows grid, agent chat), so the same workflow reads the same way
 * everywhere.
 */

const CLIENT_DATA_LABEL = 'client data';

export function hasClientDataLabel(
  labels?: { name: string }[] | null,
): boolean {
  return (labels ?? []).some(
    (label) => label.name.trim().toLowerCase() === CLIENT_DATA_LABEL,
  );
}

/** A workflow is public once anyone outside its share list can reach it. */
export function isSharedPublicly(source: {
  default_role?: string | null;
  publish_to_template?: boolean | null;
}): boolean {
  return !!(source.default_role ?? source.publish_to_template);
}
